import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { emailValidator } from '@app/commons/utils/form-utility';
import { AuthService } from '@app/services/auth.service';
import { set } from 'lscache';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator]),
  });
  errorText = '';
  forgetPasswordSuccess: boolean = false;
  successMessage: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  get emailControl() {
    return this.loginForm.controls.email;
  }

  resetPassword() {
    if (this.emailControl.valid) {
      this.authService.resetPassword(this.emailControl.value || '');
      this.showErrorMessage('Reset password email has been sent, please follow the steps thanks.');
      this.resetForm();
  
      // Step 1: render the success UI FIRST
      this.forgetPasswordSuccess = true;
  
      // Step 2: THEN update message (this triggers VoiceOver)
      setTimeout(() => {
        this.successMessage =
          "Please check your inbox for the password recovery email we've just sent you";
      }, 100);
  
    } else {
      this.showErrorMessage('Please enter email address to continue.');
    }
  }

  resetForm() {
    this.loginForm.setValue({
      email: '',
    });
  }

  showErrorMessage(message: string) {
    this.errorText = message;
    setTimeout(()=>{
      this.errorText = '';
    }, 3000)
  }

  back() {
    this.router.navigate(['login']);
  }
}
